import React, { useRef } from 'react';
import VCHeroSection from '../../../components/landingPage/VCPage/VCHeroSection';
import VCStatsBand from '../../../components/landingPage/VCPage/VCStatsBand';
import VCTabsSection from '../../../components/landingPage/VCPage/VCTabsSection';
import VCQuotesSection from '../../../components/landingPage/VCPage/VCQuotesSection';
import VCPricingSection from '../../../components/landingPage/VCPage/VCPricingSection';
import VCCtaSection from '../../../components/landingPage/VCPage/VCCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const LandingHomeVCs = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <VCHeroSection />
            <VCStatsBand />
            <VCTabsSection />
            <VCQuotesSection />
            <VCPricingSection />
            <VCCtaSection />
        </div>
    );
};

export default LandingHomeVCs;
